module.exports = __webpack_public_path__ + "media/images/lane/shape-4b99c8106fc133c6d48d0b15af9a2125.svg";